// mixin for listing products

import pluralize from 'pluralize'
import { mapGetters } from 'vuex'
import moment from 'moment'
import 'moment-timezone'
import { checkDealSchedule } from '../../utils/dealSchedule.js'

export default {
  data () {
    return {
      selected: 'all'
    }
  },
  computed: {
    ...mapGetters([
      'products',
      'createYourOwnProduct',
      'freePizzaRewardDeal',
      'timezone',
      'currentStore',
      'storeInfo',
      'currentMoment'
    ]),
    productType () {
      if (this.$platform === 'pos') {
        return pluralize(this.$route.path.replace('/ordering/menu/', ''), 1)      
      }
      return pluralize(this.$route.path.replace('/menu/', ''), 1)
    },
    groupingTags () {
      const tags = this.products[this.productType] ? this.products[this.productType].grouping_tags : []
      if (tags.length) {
        if (this.$platform !== 'pos') {
          return [...tags, 'others']
        }
        return tags
      }
      return []
    },
    groups () {
      if (this.products[this.productType]) {
        let list = this.products[this.productType].items
        if (this.$platform !== 'pos' && this.productType === 'pizza' && this.createYourOwnProduct) {
          list = list.filter(item => item.id !== this.createYourOwnProduct.id)
        }
        if (this.productType === 'deal') {
          list = list.filter(item => checkDealSchedule(item, this.storeInfo ? this.storeInfo.schedule : null, null, this.currentMoment))
        }
        if (this.selected !== 'all') {
          list = list.filter((item) => {
            return item.tags.includes(this.selected)
          })
        }
        const listGroup = {}
        this.groupingTags.forEach((tag) => {
          listGroup[tag] = list.filter(product => product.tags.includes(tag))
        })
        listGroup.others = list.filter((product) => {
          const contains = product.tags.filter(tag => this.groupingTags.includes(tag))
          return !contains.length
        })
        return listGroup
      }
      return null
    },
    filteringTags () {
      const tags = this.products[this.productType] ? this.products[this.productType].filtering_tags : []
      if (tags.length) {
        return ['all', ...tags]
      }
      return []
    }
  },
  methods: {
    getDatetime (datetime) {
      if (datetime) {
        datetime = datetime.split(':')
        datetime = datetime.filter(item => !isNaN(parseInt(item))).map(item => parseInt(item))
        if (datetime.length === 3
          && datetime[0] >=0 && datetime[0] <= 23
          && datetime[1] >=0 && datetime[1] <= 59
          && datetime[2] >=0 && datetime[2] <= 59) {
            return moment().set({ hour: datetime[0], minute: datetime[1], second: 0 })
        }
      }
      return false
    }
  },
  mounted () {
    moment.tz.setDefault(this.timezone)
  }
}